var ResourceBaseFlash = (function () {
    function ResourceBaseFlash() {
    }
    Object.defineProperty(ResourceBaseFlash.prototype, "id", {
        get: function () {
            return this._pId;
        },
        enumerable: true,
        configurable: true
    });
    ResourceBaseFlash.prototype.dispose = function () {
    };
    ResourceBaseFlash.prototype.generateMipmaps = function () {
        //TODO
    };
    return ResourceBaseFlash;
}());
export { ResourceBaseFlash };



// WEBPACK FOOTER //
// ../dist/lib/flash/ResourceBaseFlash.js